import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withErrorBoundary } from '../../../hocs/withErrorBoundary';

import {
  actions as successActions,
  successMsgSelector,
  successValuesForMsgSelector,
  succesTypeSelector,
  successAlertBoxTitleSelector,
} from '../../../redux/ui/success';
import {
  actions as errorActions,
  errorMsgSelector,
  errorIsStaticFlowSelector,
  infoErrorIconSelector,
} from '../../../redux/ui/error';

const mapStateToProps = state => ({
  message: successMsgSelector(state),
  errorMessage: errorMsgSelector(state),
  iconType: succesTypeSelector(state),
  values: successValuesForMsgSelector(state),
  isStaticFlow: errorIsStaticFlowSelector(state),
  infoErrorIcon: infoErrorIconSelector(state),
  title: successAlertBoxTitleSelector(state),
});

const mapDispatchToProps = {
  update: successActions.update,
  updateError: errorActions.update,
};

export const enhance = compose(
  withErrorBoundary,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/common/AppAlert/enhance.js